import { Inject, Options, Prop, Provide, Vue, Watch } from "vue-property-decorator";
import { TrustAPI } from "@/shared/modules/trust-api";
import { AppInsights } from "@/trust-atcs-app/appInsights";
import { ComplianceForm, PartAFormOverview } from "@/shared/modules/typescript-trustapi-client/models";
import { EventEmitter } from "events";
import store from "@/trust-atcs-app/store";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";

@Options({
  components: {
    LoadingSpinner
  },
  emits: ['update:isSectionLoading', 'setFormDesc', 'validForm'],
  mixins: [FormatDateTimeMixin],
})
export default class FormPartBOverview extends Vue {

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private isSectionLoading!: boolean;

  @Inject({ from: 'complianceStartYear', default: '' })
  private complianceStartYear!: string;

  @Inject({ from: 'complianceEndYear', default: '' })
  private complianceEndYear!: string;


  @Watch('loadingContent')
  private sectionLoading() {
    this.$emit('update:isSectionLoading', this.loadingContent);
  }

  private ai = new AppInsights;
  private loadingContent = false;
  private errorLoadingContent = false;

  private overviewContent: PartAFormOverview = null as any;

  mounted(): void {
    this.loadOverviewContent();
  }

  private async loadOverviewContent(): Promise<void> {
    try {
      this.loadingContent = true;
      const resp: any = await this.apiService.PartBFormApi?.apiV2PartBFormGetOverviewPost({
        complianceFormId: this.complianceFormB.id,
        updatingKey: this.updatingKey,
        manageSignatoryUpdatingKey: this.signatoriesUpdatingKey
      });

      if (!this.signatoriesUpdatingKey) {
        store.dispatch('setSignatoriesUpdatingKey', resp.data.data.manageSignatoryUpdatingKey);
      }

      this.overviewContent = resp.data.data as PartAFormOverview;
      this.$emit('setFormDesc', this.$formatDateFullDate(this.overviewContent?.complianceYearEnd));

      store.dispatch('setFormUpdatingkey', this.overviewContent.updatingKey);
    } catch (err: any) {
      if (err.response.status === 400 && err.response.data?.errorCode == 10001) {
        // handle resubmit request in app.ts
      } else {
        this.eventCtrl.emit('show-snackbar', 'error', 'Error loading content' + err);
        this.errorLoadingContent = true;
      }
    } finally {
      this.loadingContent = false;
    }
  }

  get complianceFormB(): ComplianceForm {
    return store.getters.getSelectedComplianceFormB;
  }

  get updatingKey(): string {
    return store.getters.getFormUpdatingKey;
  }

  get signatoriesPracticeCoreId(): number | null {
    return store.getters.getSelectedPracticeCoreId;
  }

  get signatoriesUpdatingKey(): string {
    return store.getters.getSignatoriesUpdatingKey;
  }

}